import React, { useEffect, useState } from "react";
import { pdf } from '@react-pdf/renderer';
import { useParams } from 'react-router-dom';
import { Page, Text, View, Document, StyleSheet, Font, Image} from '@react-pdf/renderer';
import UserService from "../../controllers/UserService";
import AuthService from "../../controllers/AuthService";
import strengths from "../../files/strengths.json";
import $ from 'jquery'
Font.register('/font/Sarabun-Regular.ttf', { family: 'SarabunRegular' } );
Font.register('/font/Sarabun-Bold.ttf', { family: 'SarabunBold' } );



function PdfDevelopSelf() {

    const { roomId, code, studentId } = useParams();

    const [headerText, setHeaderText] = useState('กิจกรรม Friendship ');
    const [userFullName, setUserFullName] = useState(AuthService.getUserFullName());     

    let newStrengths = [];
    let teacher = '';    
    let content = '';    
    const regex = /(<([^>]+)>)/ig; 
    const regex1 = /\&nbsp;/g;
    const regex2 = /  +/g;
    // const regex3 = /[\uE000-\uF8FF]/g;  202F
    const regex3 = /[\u202F]/g;
    // const regex3 = /\ /g;
    const regex4 = /\ /g;
    let school = null;
    let logo = UserService.getLogoUrl();   
    let room = null;
    let dateString = '';
    let student = '';
    let content2 = [];
    let text1 = '';
    let text2 = '';

    const generateDate = (dateTime) => {     
        // console(formattedDate, formattedMonth);
        var months_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
        var temp = dateTime.getFullYear() + 543;
        return dateTime.getDate() + ' ' + months_th[dateTime.getMonth()] + ' ' + temp;
    }

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();    
    var dateTemp = new Date(yyyy+'-'+mm+'-'+dd);
    dateString = generateDate(dateTemp);  

    const processContent = (ctx) => {       
        if( ctx !== undefined ){
            ctx = ctx.replace(regex, ' ');
            ctx = ctx.replace(regex1, ' ');  
            ctx = ctx.replace(regex2, ' ');  
            ctx = ctx.replace(regex3, ' ');  
            ctx = ctx.replace(regex4, ' '); 
            try {
                ctx = decodeURI(ctx);
            }
            catch(err) {}
        } else {
            ctx = '';
        }
        
        let tempPlusStart = 0;
        let result = []
        var start = 0;
        // let limit = 82;
        let limit = 70;
        for(let i = 0; i <= ((ctx.length)/limit+1); i++){
            // find last char                      
            
            var length = start+limit;       

            var tempString = ctx.slice(start, length);
            var focusVowls = (tempString.match( /["่","้","๋","๊","็","ั","ี","ึ","ื","ิ","ุ","ู","์","ั"]/g) || []).length;
            // console.log(tempString,focusVowls);
            length = length+(focusVowls);            

            var pre =  ctx[length-2]; 
            var last =  ctx[length-1]; 
            var next = ctx[length]; 
           
         
            // start += tempPlusStart;
      
            tempPlusStart = 0;
     

            var vowels  = ["า", "ำ", "ะ","่","้","๋","๊","็","ั", " ","ี","ึ","ื","ิ","ุ","ู","์"];
            var vowels2  = ["เ", "ไ", "ใ", "แ","ั"," "];
            
            var result1 = vowels.includes(last);
            var result2 = vowels2.includes(last);

            var result3 = vowels.includes(next);
            var result4 = vowels2.includes(pre);
            // console.log(pre,last,next,result1,result2,result3);
            if(result3){
                //next is ["า", "ำ", "ะ","่","้","๋","๊","็","ั", " "];    
                if(next !== ' '){
                    // console.log('44444444444');
                    length -= 1;
                    tempPlusStart-= 1;
                    if(!(/^[ก-ฮa-zA-Z]+$/ig.test(last))){ 
                        // console.log('55555555555555');
                        length -= 1;
                        tempPlusStart-= 1;                        
                    }

                    if(result4){ 
                        // console.log('6666666');
                        length -= 1;
                        tempPlusStart-= 1;
                        
                    }
                }            
               
            } else if( !(/^[ก-ฮa-zA-Z]+$/ig.test(last)) && !result1){
                //check should plus or minus          
                if(result2){
                    // vowels2
                    // console.log('1111111111');
                    length -= 1;
                    tempPlusStart-= 1;
                    // if(!(/^[ก-ฮa-zA-Z]+$/ig.test(pre))){ 
                    //     length -= 1;
                    //     tempPlusStart-= 1;
                    // }
                } else {
                    if(!(/^[ก-ฮa-zA-Z]+$/ig.test(next)) && !result3) {
                        // console.log('2222222222');
                        length -= 1;
                        tempPlusStart-= 1;
                    } else {
                        // console.log('33333333333');
                        length += 1;
                        tempPlusStart+= 1;
                    }
                }


            }
          
            result.push(ctx.slice(start, length) + " ");     
            start =+ length; 
            // console.log('--------------------------------------');                         

        }
        return (result.join('\n')).trim();
    }

    useEffect(() => {       
        
        UserService.getStrengths().then((response) => {         
            console.log(code);
            console.log(response.data.data);       
            for (const [index, str] of response.data.data.entries()) {   
                
                if(code === str.id){
                    console.log(str.id);                    
                    text1 = str.name;
                    text2 = processContent(str.suggestion);
                }
            }           
        }).then(() => {
            //get student datail         
           UserService.getUserById(studentId).then(
            (res) => {
                console.log(res.data);
                student = res.data.data.fullName;
                school = res.data.data.domain.displayName;
                //logo =  '/images/school/'+ res.data.data.domain.id + '_' +res.data.data.domain.name +'.png';  
                logo = UserService.getLogoUrl();            
                
               
            }).then(() => {
               //get room 
               UserService.getRoomDetail(roomId).then((res) => {         
                        console.log(res);   
                        room = res.data.data.displayName;        
                        teacher = res.data.data.teachers[0].fullName;
                        
                    }).then(async () => {
                        await savePdf(MyDocumentFriendShip(), "friendship.pdf");
                        setTimeout(() => {window.close(); }, 2000)
                    });              
            });
        });       
        
    }, []);



    const MyDocumentFriendShip = () => {
        return (
            <Document>
                <Page size="A4" style={styles.page} wrap>      
                {/* <View style={styles.header} fixed>           
                    <View style={styles.headerLeft}>               
                            <View style={styles.logo}>
                                <Image style={styles.image} src={logo} />                                
                            </View>       
                            <View style={styles.THL}>  
                                <Text style={styles.HLB}>{school}</Text>                         
                                <Text style={styles.HLR}>วันที่ออกรายงาน : {dateString} ครูประจำชั้น : {teacher}</Text>   
                            </View>                   
                    </View>           
                    <View style={styles.headerRight}>
                        <Text style={styles.HLB}>{headerText} {room}</Text>
                        <Text style={styles.HLR}>ผู้ออกรายงาน : {userFullName}</Text>            
                    </View>            
                </View> */}

                <View style={styles.header100} fixed>               
                    <View style={styles.logo1}>
                        <Image style={styles.image} src={logo} />                                
                    </View>       
                    <View style={styles.THL1}>  
                        <Text style={styles.HLB}>{school}</Text>                         
                        <Text style={styles.HLR}>วันที่ออกรายงาน : {dateString} ครูประจำชั้น : {teacher}</Text>  
                    </View>          
                    <View style={styles.THL2}>
                        <Text style={styles.HLB}>{headerText} {room}</Text>
                        <Text style={styles.HLR}>ผู้ออกรายงาน : {userFullName}</Text>            
                    </View>         
                </View>       
                
                <View style={styles.divRow} fixed>
                    <View style={styles.headerLeft}>
                        <Text style={styles.textBlue}>รายงานของ : {student}</Text>    
                    </View>                    
                </View>   
                
                <View >
                    <View style={styles.divRow} breaks>
                        <Text style={styles.titleCenter}>แนวทางการพัฒนาตัวเองจากอุปนิสัยเชิงบวก</Text>
                    </View>
                    <View style={styles.divRow}>
                        <Text  style={styles.width100NormalTextTitle}>{text1}</Text>
                    </View>  
                    <View style={styles.divRow}>
                        <Text  style={styles.width100NormalText}>{text2}</Text>
                    </View>                  
                </View>               


                <View style={styles.footer} fixed>   
                    <View style={styles.headerLeft}>               
                        <Text style={styles.footerTextL} >ออกโดยบริษัท MINDSET MAKER CO., LTD.</Text>            
                    </View>           
                    <View style={styles.headerRight}>
                        <Text style={styles.footerTextR} render={({ pageNumber, totalPages }) => (
                            `หน้า : ${pageNumber}/${totalPages}`
                        )} fixed />       
                    </View>    
                </View>
                </Page>
    
            </Document>
        )
    }

    return ''
};


const saveBlob = (blob, filename) => {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style.display = "none";
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
};


const savePdf = async (document, filename) => {
    saveBlob(await pdf(document).toBlob(), filename);
};

const styles = StyleSheet.create({
   
    page: {       
        paddingBottom: 30
    },
    footer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: 10,          
      display: 'flex',
      flexDirection: 'row',  
    },

    footerTextR: { 
        textAlign: 'right',
        fontSize: 10,
        fontFamily: 'SarabunRegular',
        lineHeight: 1.5,
        color: '#828282',
    },

    footerTextL: { 
        textAlign: 'left',
        fontSize: 10,
        fontFamily: 'SarabunRegular',
        lineHeight: 1.5,
        color: '#828282',
    }, 
    header: {
        borderBottomWidth: 1,
        borderBottomColor: '#C4C4C4',
        color: '#000000',
        margin: 30,
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 10,        
    },
    headerLeft: {
        textAlign: 'left',
        flex: 1,
        alignSelf: 'center',     
        display: 'flex',
        flexDirection: 'row', 
    },
    headerRight: {
        textAlign: 'right',
        flex: 1  
    },  
    HLB: {
        fontSize: 14,
        fontWeight: 900,
        lineHeight: 1.5,
        color: '#000000',
        fontFamily: 'SarabunBold',   
    },
    HLR: {
        fontSize: 10,
        lineHeight: 1.5,
        color: '#000000',
        fontFamily: 'SarabunRegular',   
    },
    image: {
        width: "100%",      
    },
    logo: {
        paddingRight: 5,
        width: "15%",
    },
    THL: {
     width: "85%",
    },   
    header100: {
        borderBottomWidth: 1,
        borderBottomColor: '#C4C4C4',
        color: '#000000',
        margin: 30,
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 10,         
    },
    logo1: {
        paddingRight: 5,
        width: "7%",
    },
    THL1: {
     width: "60%",
    },  
    THL2: {
        textAlign: 'right',
        width: "33%",
    },
    tableRowWhite: {
        padding: 10,
        display: 'block',
        flexDirection: 'row',    
    },
    divRow: {
        color: '#000000',
        padding: 30,
        paddingBottom: 5,
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'row',
        // overflowWrap: 'anywhere',
        // whiteSpace: 'break-spaces',
    },
    textBlue: {
        fontSize: 14,
        color: '#3765D1',
        lineHeight: 1.5,       
        fontFamily: 'SarabunRegular',       

    },
    boxLeft: {
        textAlign: 'left',
        flex: 1,
        alignSelf: 'left',     
        display: 'flex',
        flexDirection: 'row',
    },
    boxRight: {
        textAlign: 'right',
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'right',
    },
    icon1: {
        marginLeft: 100,
        paddingRight: 0,
        width: "10%",        
    },  
    titleCenter: {
        textAlign: 'center',
        fontSize: 16,
        fontFamily: 'SarabunBold',
        paddingBottom: 10,
        paddingTop: 20,
        lineHeight: 1.5,
    },
    width100NormalText: {
        color: '#000000',
        fontSize: 14,
        fontFamily: 'SarabunRegular',  
        width: "100%",
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        textAlign: 'center',
        overflowWrap: 'anywhere',
        whiteSpace: 'break-spaces',
    },
    width100NormalTextTitle: {
        color: '#000000',
        fontSize: 16,
        fontFamily: 'SarabunBold',  
        width: "100%",
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        textAlign: 'center',
        overflowWrap: 'anywhere',
        whiteSpace: 'break-spaces',
        color: '#3765D1',
    },
    width33: {
        width: "33.33%",
    },
    width100: {
        width: "100%"
    },  
    image1: {
        paddingTop: 10,
        paddingBottom: 10,
        textAlign: 'center'
    },
    image3: {
        paddingTop: 10,
        paddingBottom: 10,
        paddingHorizontal: 50,
        textAlign: 'center'
    },

});
export default PdfDevelopSelf;